// extracted by mini-css-extract-plugin
export default {"latestMainBox":"LatestOrder_latestMainBox__OzQJ4","latestLine":"LatestOrder_latestLine__0r2fA"};